import React from 'react';
import { StarIcon } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  location: string;
  age: number;
  quote: string;
}
export function TestimonialCard({
  name,
  location,
  age,
  quote
}: TestimonialCardProps) {
  return <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-100 flex flex-col h-full" data-id="element-24">
      <div className="flex gap-1 mb-4" data-id="element-25">
        {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-26" />)}
      </div>
      <p className="text-gray-700 italic mb-6 flex-grow text-lg" data-id="element-27">"{quote}"</p>
      <div className="flex items-center gap-3 mt-auto border-t pt-4 border-gray-100" data-id="element-28">
        <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center text-green-700 font-bold text-sm" data-id="element-29">
          {name.charAt(0)}
        </div>
        <div data-id="element-30">
          <p className="font-bold text-gray-900" data-id="element-31">
            {name}, {age}
          </p>
          <p className="text-sm text-gray-500" data-id="element-32">{location}</p>
        </div>
      </div>
    </div>;
}